<template>
  <button class="tx-dealersearch module-filter-category" :class="{ '-filterOn': filterOn }" @click="handleClick">
    <span>{{ category.title }}</span>
  </button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FilterCategory',
  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      filterCategories: state => state.attribute.filterCategories
    }),
    filterOn () {
      if (this.filterCategories.includes(this.category.uid)) {
        return true
      }
      return false
    }
  },
  methods: {
    handleClick () {
      if (!this.filterOn) {
        this.$emit('addFilter')
      } else {
        this.$emit('removeFilter')
      }
    }
  }
}
</script>
